import StockListPage from "./StockListPage"
import Theme from "./Theme"
import { Navbar } from "./components/Navbar"

function App() {
  return (
    <div className="App">
      <Theme>
        <Navbar />
        <StockListPage />
      </Theme>
    </div >
  )
}

export default App
